import { useEffect } from 'react';
import { getAdSenseClientId } from '@/lib/adsense-config';

declare global {
  interface Window {
    adsbygoogle: any[];
  }
}

export function AdSenseScript() {
  const publisherId = getAdSenseClientId();

  useEffect(() => {
    if (!publisherId) return;

    const script = document.createElement('script');
    script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${publisherId}`;
    script.async = true;
    script.crossOrigin = 'anonymous';
    
    const existingScript = document.querySelector(`script[src*="adsbygoogle"]`);
    if (!existingScript) {
      document.head.appendChild(script);
    }

    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, [publisherId]);

  return null;
}
